module.exports = __webpack_public_path__ + "img/d-fbom-en.8927544a.gif";